import { AbstractControl, ValidatorFn } from '@angular/forms';
import { IBatchAttachmentViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { AttachmentFileType } from '@view-models/enums/attachment-file-type.enum';
import { FileExtPipe } from '@widgets/ui-common/pipes/file-ext/file-ext.pipe';

export function minUploadCount(length: number): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value as Array<IBatchAttachmentViewModel>;
    if (value.length < length) {
      return {
        minUploadCount: {
          length
        }
      };
    }
    return null;
  };
}

export function maxUploadCount(length: number): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value as Array<IBatchAttachmentViewModel>;
    if (value.length > length) {
      return {
        maxUploadCount: {
          length
        }
      };
    }
    return null;
  };
}

export function minUploadSize(size: number): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value as Array<IBatchAttachmentViewModel>;
    const errors = value.filter(t => t.fileSize < size);
    if (errors.length > 0) {
      return {
        minUploadSize: {
          minSize: size,
          indices: errors.map(t => value.indexOf(t))
        }
      };
    }
    return null;
  };
}

export function maxUploadSize(size: number): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value as Array<IBatchAttachmentViewModel>;
    const errors = value.filter(t => t.fileSize > size);
    if (errors.length > 0) {
      return {
        maxUploadSize: {
          maxSize: size,
          indices: errors.map(t => value.indexOf(t))
        }
      };
    }
    return null;
  };
}

export function uploadRequired(): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value as Array<IBatchAttachmentViewModel>;
    if (value.length === 0) {
      return {
        uploadRequired: true
      };
    }
    return null;
  };
}

export function allowedFileTypes(...fileTypes: string[]): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value as Array<IBatchAttachmentViewModel>;
    const errors = value.filter(t => {
      const fileExt = FileExtPipe.getFileExtension(t.fileName).toUpperCase();
      return !fileTypes.includes(fileExt);
    });

    if (errors.length > 0) {
      return {
        allowedFileTypes: {
          fileTypes: Object.keys(AttachmentFileType),
          indices: errors.map(t => value.indexOf(t))
        }
      };
    }
    return null;
  };
}
